export default "__VITE_ASSET__DGGsgzEe__"